import "moment/locale/en-gb";
import React, { FC, useEffect } from "react";
import "react-dates/lib/css/_datepicker.css";
import "@styles/form.css";
import {
  FormBase,
  FormProps,
  InputDateRange,
  InputText,
  InputTextArea,
  InputFileUpload,
  ImageWithFade,
  InputSelect,
} from "@components-common/forms";
import { Course } from "./_types";
import { IconTalTech } from "../../../components-common/icons";
import { Col, Row } from "taltech-styleguide";
import { useField, useFormikContext } from "formik";
import { application } from "../../../_runtime/bootstrap";
import { useNavigate } from "react-router-dom";

const courseStates = ["DRAFT", "ACTIVE", "ARCHIVED"];

const CourseFormContent: FC<FormProps<Course> & { isEditForm: boolean }> = ({
  isEditForm,
}) => {
  const [fieldContents] = useField("contents");
  const [fieldUrl] = useField("picture.url");
  const [imageUrl, setImageUrl] = React.useState<string>(fieldUrl.value || "");

  useEffect(() => {
    if (fieldContents.value) {
      setImageUrl(fieldContents.value || "");
    }
  }, [fieldContents.value]);

  const body = (
    <>
      <Col id="courseLogo" xs="12" md="4" lg="4" xl="2">
        <div className={"uploader-wrapper"}>
          <div className={"uploader"}>
            <InputFileUpload text="" />
          </div>
          <div className="img-div">
            {imageUrl !== "" ? (
              <ImageWithFade url={imageUrl} />
            ) : (
              <IconTalTech kind="course" />
            )}
          </div>
        </div>
      </Col>
      <Col md="8" lg="8" xl="10" className="d-flex flex-column gap-2">
        <InputText
          id="number"
          label="Number (3 letters followed by 4 numbers. Example: TTU0001)"
          elementClass="required"
        />
        <InputText id="name" elementClass="required" />
        <InputTextArea id="description" />
        {isEditForm && <InputSelect id="state" items={courseStates} />}
        <InputDateRange />
      </Col>
    </>
  );
  return body;
};

export const CourseForm: FC<FormProps<Course>> = ({ ...props }) => {
  const nav = useNavigate();
  const formik = useFormikContext();
  useEffect(() => {
    if (formik.isSubmitting) {
      const values: any = formik.values;
      const data = {
        number: values.number,
        name: values.name,
        description: values.description,
        state: values.state,
        startDate: values.startDate,
        endDate: values.endDate,
      };
      if (formik.isValid) {
        if (props.id === "form_create") {
          application
            .getHttpClient()
            .post("/coursesms/courses", data)
            .then((res: any) => {
              if (values.fileName !== "") {
                application
                  .getHttpClient()
                  .put(`/coursesms/courses/${res.body.id}/logo`, {
                    contents: values.contents.replace(
                      "data:image/png;base64,",
                      ""
                    ),
                    fileName: values.fileName,
                  })
                  .then(() => {
                    nav("/courses");
                    formik.setSubmitting(false);
                  });
              } else {
                nav("/courses");
                formik.setSubmitting(false);
              }
            })
            .catch((e) => {
              formik.setSubmitting(false);
            });
        } else {
          application
            .getHttpClient()
            .put(`/coursesms/courses/${values.id}`, data)
            .then((res: any) => {
              if (values.contents) {
                application
                  .getHttpClient()
                  .put(`/coursesms/courses/${values.id}/logo`, {
                    contents: values.contents.replace(
                      "data:image/png;base64,",
                      ""
                    ),
                    fileName: values.fileName,
                  })
                  .then(() => {
                    nav(`/courses`);
                    formik.setSubmitting(false);
                  });
              } else {
                nav(`/courses`);
                formik.setSubmitting(false);
              }
            })
            .catch((e) => {
              formik.setSubmitting(false);
            });
        }
      }
    }
  }, [formik.isSubmitting]);
  return (
    <Row>
      <CourseFormContent {...props} isEditForm={props.id !== "form_create"} />
    </Row>
  );
};
